import { FC } from "react";

// eslint-disable-next-line no-restricted-imports
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";

export const LoadingOverlay: FC = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(255,255,255,0.9)",
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={20} />
    </Box>
  );
};
